import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {CommonService} from '../../common/controller/common.service';




import {ApiMessageService} from '../../core/api-message.service';
import {Router} from '@angular/router';
import {JsonBaseBuilder} from '../../common/builder/json-base-builder';
import {RuoloPersona} from './ruolopersona.model';
import {ConfigService} from '../../core/config.service';
import {Table} from '../../common/model/table.model';
import {MODULE_ANAGRAFICA} from '../../app-routing.module';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {Helpers} from '../../common/helpers/helpers';

@Injectable()
export class RuoloPersonaService extends CommonService<RuoloPersona> {

  public static ROUTE = 'ruolopersona';

  public constructor(protected httpClient: HttpClient,
                     protected apiMessageService: ApiMessageService,
                     protected router: Router,
                     protected configService: ConfigService) {
    super(httpClient, apiMessageService, router, configService);
  }

  public buildInstance(json: any): RuoloPersona {
    return JsonBaseBuilder.jsonToRuoloPersona(json);
  }

  public getModule(): string {
    return MODULE_ANAGRAFICA;
  }

  public getApiService(): string {
    return ConfigService.ACE;
  }

  public getTable(items: RuoloPersona[]): Table {
    return Table.buildBaseTable(RuoloPersona.getTableKeys(), items);
  }

  public getRoute(): string {
    return RuoloPersonaService.ROUTE;
  }

  public getRuoloResponsabileStrutturaByIdEntita(id: string, dateRif: Date): Observable<RuoloPersona> {
    return this.getAny('/struttura/responsabile/byIdEntita', 
        new HttpParams().set('idEntitaorganizzativa', id)
                        .set('dateRif', Helpers.formatDate(dateRif))).pipe(map((item) => {
      const instance: RuoloPersona = this._buildInstance(item);
      return instance;
    }));
  }
}